<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <img src="@/assets/logo.jpg" alt="北京行序科技" class="logo">
        <h2>北京行序科技官网后台管理系统</h2>
      </div>
      <el-card class="login-card">
        <h2>管理员登录</h2>
        <el-form :model="loginForm" @submit.prevent="handleLogin">
          <el-form-item>
            <el-input v-model="loginForm.username" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="loginForm.password" type="password" placeholder="密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import request from '@/utils/request'  // 使用封装的 request
import { ElMessage } from 'element-plus'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()
    const loading = ref(false)
    const loginForm = ref({
      username: '',
      password: ''
    })

    const handleLogin = async () => {
      if (!loginForm.value.username || !loginForm.value.password) {
        ElMessage.warning('请输入用户名和密码')
        return
      }

      try {
        loading.value = true
        const response = await request.post('/admin/login', loginForm.value)
        
        localStorage.setItem('token', response.token)
        localStorage.setItem('username', response.username)
        
        ElMessage.success('登录成功')
        
        const redirectPath = route.query.redirect || '/admin'
        router.push(redirectPath)
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '登录失败')
      } finally {
        loading.value = false
      }
    }

    return {
      loginForm,
      loading,
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-box {
  width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 20px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.login-card {
  width: 400px;
}
</style> 